//documentation: ninja-keys via context7 or https://github.com/ssleptsov/ninja-keys

import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"
import "ninja-keys"

// Connects to data-controller="command-palette"
export default class extends Controller {
  static values = {
    clipsUrl: { type: String, default: '/' },
    reprocessClipTitle: { type: String, default: 'Reprocess clip' },
    isAdmin: { type: Boolean, default: false },
    isDevelopment: { type: Boolean, default: false },
    isSignedIn: { type: Boolean, default: false }
  }

  connect() {
    // Track current submenu
    this.currentParent = null;
    
    this.allActions = [
      {
        id: 'ClipsParent',
        title: 'Clips',
        section: 'Clips',
        hotkey: 'ctrl+alt+c',
        children: ['GoToClips'],
        shouldShow: () => this.isSignedInValue,
        handler: () => {
          // Just keep menu open, selected event will handle the rest
          return { keepOpen: true }
        }
      },
      {
        id: 'UsersParent',
        title: 'Users',
        section: 'Users',
        hotkey: 'ctrl+alt+u',
        children: ['GoToProfile', 'SignIn', 'SignOut'],
        handler: () => {
          return { keepOpen: true }
        }
      },
      {
        id: 'GoToProfile',
        title: 'Go to profile',
        section: 'Users',
        parent: 'UsersParent',
        keywords: 'users profile account settings',
        handler: () => {
          visit("/users/edit")
        },
        shouldShow: () => this.isSignedInValue
      },
      {
        id: 'SignOut',
        title: 'Sign out',
        section: 'Users',
        parent: 'UsersParent',
        keywords: 'sign out log out logout signout',
        handler: () => {
          // Create and submit a form with DELETE method
          const form = document.createElement('form')
          form.method = 'POST'
          form.action = '/users/sign_out'
          
          const methodInput = document.createElement('input')
          methodInput.type = 'hidden'
          methodInput.name = '_method'
          methodInput.value = 'delete'
          form.appendChild(methodInput)
          
          const tokenInput = document.createElement('input')
          tokenInput.type = 'hidden'
          tokenInput.name = 'authenticity_token'
          tokenInput.value = this.csrfToken() ?? ''
          form.appendChild(tokenInput)
          
          document.body.appendChild(form)
          form.setAttribute('data-turbo', 'false')
          form.submit()
        },
        shouldShow: () => this.isSignedInValue
      },
      {
        id: 'SignIn',
        title: 'Sign in',
        section: 'Users',
        parent: 'UsersParent',
        keywords: 'sign in log in login signin',
        handler: () => {
          visit("/users/sign_in")
        },
        shouldShow: () => !this.isSignedInValue
      },
      {
        id: 'GoToClips',
        title: 'Go to clips list',
        section: 'Clips',
        parent: 'ClipsParent',
        handler: () => {
          visit(this.clipsUrlValue)
        },
        shouldShow: () => this.isSignedInValue
      },
      {
        id: 'DevTools',
        title: 'Developer tools',
        hotkey: 'ctrl+shift+D',
        section: 'Developer',
        children: ['GoToJobs', 'ReprocessClip'],
        handler: () => {
          return { keepOpen: true }
        },
        shouldShow: () => this.isAdminValue || this.isDevelopmentValue
      },
      // {
      //   id: 'GoToSubmission',
      //   title: 'Go to specific submission',
      //   section: 'Submissions',
      //   parent: 'SubmissionsParent',
      //   hotkey: 'ctrl+G',
      //   handler: () => {
      //     const submissionId = prompt('Enter submission ID or hashid:');
      //     if (submissionId && submissionId.trim()) {
      //       visit(`/submissions/${submissionId.trim()}`);
      //     }
      //   },
      //   shouldShow: () => this.isSignedInValue
      // },
      // {
      //   id: 'Certifications',
      //   title: 'Go to certifications',
      //   hotkey: 'ctrl+A',
      //   handler: () => {
      //     visit("/certifications")
      //   },
      //   shouldShow: () => this.isSignedInValue
      // },
      // {
      //   id: 'Settings',
      //   title: 'Go to settings',
      //   hotkey: 'ctrl+S',
      //   handler: () => {
      //     visit("/settings")
      //   }
      // },
      // // Developer Tools parent section - admin only
      // {
      //   id: 'DevTools',
      //   title: 'Developer tools',
      //   hotkey: 'ctrl+D',
      //   section: 'Developer',
      //   children: ['EnableConsole', 'DisableConsole', 'DisableProfiling', 'EnableProfiling', 'SwitchToEnglish', 'SwitchToDutch', 'RemoveLanguage'],
      //   handler: () => {
      //     // Just keep menu open, selected event will handle the rest
      //     return { keepOpen: true }
      //   },
      //   // Show if admin OR in development environment
      //   shouldShow: () => this.isAdminValue || this.isDevelopmentValue
      // },
      // {
      //   id: 'EnableConsole',
      //   title: 'Enable Rails console',
      //   hotkey: 'ctrl+`',
      //   parent: 'DevTools',
      //   handler: () => {
      //     const url = new URL(window.location.href);
      //     url.searchParams.set('console', 'true');
      //     visit(url.toString());
      //   },
      //   // Only show to admins when console is not active
      //   shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('console=true')
      // },
      // {
      //   id: 'DisableConsole',
      //   title: 'Disable Rails console',
      //   parent: 'DevTools',
      //   handler: () => {
      //     const url = new URL(window.location.href);
      //     url.searchParams.delete('console');
      //     visit(url.toString());
      //   },
      //   // Only show to admins when console is active
      //   shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && window.location.href.includes('console=true')
      // },
      // {
      //   id: 'DisableProfiling',
      //   title: 'Disable Rack Mini Profiler',
      //   parent: 'DevTools',
      //   handler: () => {
      //     const url = new URL(window.location.href);
      //     url.searchParams.set('pp', 'disable');
      //     visit(url.toString());
      //   },
      //   // Only show to admins when profiler is not disabled
      //   shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('pp=disable')
      // },
      // {
      //   id: 'EnableProfiling',
      //   title: 'Enable Rack Mini Profiler',
      //   parent: 'DevTools',
      //   handler: () => {
      //     const url = new URL(window.location.href);
      //     url.searchParams.delete('pp');
      //     visit(url.toString());
      //   },
      //   // Only show to admins when profiler is disabled
      //   shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && window.location.href.includes('pp=disable')
      // },
      // {
      //   id: 'SwitchToEnglish',
      //   title: 'Switch to English',
      //   parent: 'DevTools',
      //   keywords: 'language locale en',
      //   handler: () => {
      //     const url = new URL(window.location.href);
      //     url.searchParams.set('lang', 'en');
      //     visit(url.toString());
      //   },
      //   // Only show when not currently in English
      //   shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('lang=en')
      // },
      // {
      //   id: 'SwitchToDutch',
      //   title: 'Switch to Dutch',
      //   parent: 'DevTools',
      //   keywords: 'language locale nl',
      //   handler: () => {
      //     const url = new URL(window.location.href);
      //     url.searchParams.set('lang', 'nl');
      //     visit(url.toString());
      //   },
      //   // Only show when not currently in Dutch
      //   shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('lang=nl')
      // },
      // {
      //   id: 'RemoveLanguage',
      //   title: 'Use default language',
      //   parent: 'DevTools',
      //   handler: () => {
      //     const url = new URL(window.location.href);
      //     url.searchParams.delete('lang');
      //     visit(url.toString());
      //   },
      //   // Only show when a language parameter is present
      //   shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && 
      //     (window.location.href.includes('lang=en') || window.location.href.includes('lang=nl'))
      // },
      {
        id: 'GoToJobs',
        title: 'Go to Jobs dashboard',
        section: 'Developer',
        parent: 'DevTools',
        keywords: 'jobs solid queue mission control background',
        handler: () => {
          visit("/jobs")
        },
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue)
      },
      {
        id: 'ReprocessClip',
        title: this.reprocessClipTitleValue,
        section: 'Developer',
        parent: 'DevTools',
        keywords: 'reprocess clip',
        handler: () => {
          const clipId = this.currentClipId()
          if (!this.canReprocessCurrentClip(clipId)) return

          this.submitPost(`/${clipId}/reprocessing`)
        },
        shouldShow: () => this.isClipShowPage() && this.canReprocessCurrentClip()
      },
    ]

    // Start with empty list
    this.element.data = []

    // Handle selection of parent items
    this.element.addEventListener('selected', (event) => {
      if (event.detail.action?.children) {
        this.currentParent = event.detail.action.id
        this.updateVisibleActions()
      }
    })

    // Handle search and maintain submenu state
    this.element.addEventListener('change', (event) => {
      this.updateVisibleActions(event.detail.search)
    })

    // Reset submenu when palette closes
    this.element.addEventListener('close', () => {
      this.currentParent = null
      this.element.data = []
    })
  }

  // Single method to update visible actions based on current state
  updateVisibleActions(search = '') {
    search = search.trim()
    
    if (this.currentParent && search === '') {
      // In submenu with no search - show children
      this.element.data = this.allActions
        .filter(action => action.parent === this.currentParent)
        .filter(action => !action.shouldShow || action.shouldShow())
    } 
    else if (search === '') {
      // At root with no search - show nothing
      this.element.data = []
      this.currentParent = null
    } 
    else {
      // With search - show matching items
      this.element.data = this.allActions
        .filter(action => !action.shouldShow || action.shouldShow())
        .filter(action => !action.children)
        .filter(action => {
          const searchLower = search.toLowerCase();
          return action.title.toLowerCase().includes(searchLower) || 
                 (action.keywords && action.keywords.toLowerCase().includes(searchLower));
        })
    }
  }

  isClipShowPage() {
    if (!this.isClipsHost()) return false

    const segments = this.pathSegments()
    if (segments.length !== 1) return false

    return !this.reservedPaths().includes(segments[0])
  }

  currentClipId() {
    if (!this.isClipShowPage()) return null

    return this.pathSegments()[0]
  }

  canReprocessCurrentClip(clipId = this.currentClipId()) {
    if (!clipId) return false

    return Boolean(document.querySelector(`form[action='/${clipId}/reprocessing']`))
  }

  isClipsHost() {
    const clipsHost = new URL(this.clipsUrlValue, window.location.origin).host

    return window.location.host === clipsHost
  }

  pathSegments() {
    return window.location.pathname.split('/').filter(Boolean)
  }

  reservedPaths() {
    return ['manifest', 'service-worker', 'sign_in', 'sign_out', 'password', 'confirmation', 'unlock', 'new']
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  submitPost(path) {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = path

    const tokenInput = document.createElement('input')
    tokenInput.type = 'hidden'
    tokenInput.name = 'authenticity_token'
    tokenInput.value = this.csrfToken() ?? ''
    form.appendChild(tokenInput)

    document.body.appendChild(form)
    form.setAttribute('data-turbo', 'false')
    form.submit()
  }
}
